export default __webpack_public_path__ + "static/el_proyecto_Edutoolkit-950a2d7c752cb88c16f4020e2dc69ae2.png";